import { useQuery } from "@tanstack/react-query";
import { Button, Card } from "@rumbledirect/ui";
import { Link, useParams } from "react-router-dom";
import type { ColumnsType } from "antd/es/table";
import type {
  ImageCapture,
  ImageCapturePage,
} from "@rumble-it/common-lib/types/models/ImageCapture.interface";
import { fetchImageCaptureById } from "@/lib/api/resources/imageCaptures";
import { imageCapturePageColumns } from "./lib/constants/imageCapturePageColumns";
import { Table } from "@/components/v2";
import { PlusOutlined } from "@ant-design/icons";

export const ImageCapturePageList = () => {
  const { id: imageCaptureId } = useParams();

  const { data, isLoading } = useQuery<ImageCapture>({
    queryKey: ["imageCapture", imageCaptureId],
    queryFn: () => fetchImageCaptureById(imageCaptureId as string),
  });

  const columns: ColumnsType<ImageCapturePage> =
    imageCapturePageColumns(imageCaptureId);

  return (
    <Card
      title={`ImageCapture pagina's`}
      extra={
        <Link to={`/image-captures/${imageCaptureId}/pages/create`}>
          <Button icon={<PlusOutlined />}>Nieuwe pagina</Button>
        </Link>
      }
    >
      <Table
        rowKey={(row) => (row as ImageCapturePage).id}
        columns={columns}
        dataSource={data?.imageCapturePages}
        loading={isLoading}
        pagination={false}
        size="small"
      />
    </Card>
  );
};
